import {Document, Packer, Paragraph, TextRun, HeadingLevel, AlignmentType} from "docx";
import {saveAs} from "file-saver";
import {buildCodexPrompt, buildProductBriefText} from "./build-codex-prompt";
import {buildStrapiBackendBrief, buildStrapiBackendPrompt} from "./build-strapi-backend-prompt";

export async function exportProductBriefDocx(brief, translate) {
    const generatedAt = new Date().toLocaleDateString("fa-IR");
    const prompt = buildCodexPrompt(brief, translate);
    const strapiBrief = buildStrapiBackendBrief(brief, translate);
    const strapiPrompt = buildStrapiBackendPrompt(brief, translate);
    const briefText = buildProductBriefText(brief, translate);

    const doc = new Document({
        sections: [{
            properties: {},
            children: [
                heading("برگه محصول و Prompt Codex", HeadingLevel.TITLE),
                paragraph(`تاریخ تولید: ${generatedAt}`),
                heading("بخش 1: اطلاعات پایه"),
                ...textToParagraphs(baseInfo(brief, translate)),
                heading("بخش 2: Product Brief تکمیل‌شده"),
                ...textToParagraphs(briefText),
                heading("بخش 3: Prompt نهایی قابل تحویل به Codex"),
                ...textToParagraphs(prompt),
                heading("بخش Strapi: برگه محصول بک‌اند"),
                ...textToParagraphs(strapiBrief),
                heading("بخش Strapi: Prompt توسعه بک‌اند"),
                ...textToParagraphs(strapiPrompt),
                heading("بخش 4: موارد باز و تصمیم‌های لازم"),
                ...textToParagraphs((brief.openQuestions || []).filter(Boolean).map((item) => `- ${item}`).join("\n") || "موردی ثبت نشده است."),
                heading("بخش 5: اطلاعات فنی یا مسیر Receipt / BCR"),
                ...textToParagraphs(technicalInfo(brief)),
            ],
        }],
    });

    const blob = await Packer.toBlob(doc);
    saveAs(blob, buildFileName(brief.featureName));
}

function heading(text, level = HeadingLevel.HEADING_1) {
    return new Paragraph({
        text,
        heading: level,
        alignment: AlignmentType.RIGHT,
        bidirectional: true,
        spacing: {before: 280, after: 120},
    });
}

function paragraph(text) {
    return new Paragraph({
        alignment: AlignmentType.RIGHT,
        bidirectional: true,
        spacing: {after: 90},
        children: [new TextRun({text: String(text || ""), font: "Arial", size: 24})],
    });
}

function textToParagraphs(text) {
    return String(text || "")
        .split("\n")
        .map((line) => line.trim())
        .filter(Boolean)
        .map((line) => paragraph(line));
}

function baseInfo(brief, translate) {
    return [
        `نوع درخواست: ${brief.requestType}`,
        `نام فیچر: ${brief.featureName}`,
        `اولویت: ${brief.priority}`,
        `حالت اجرا: ${brief.codexMode}`,
        `درخواست‌دهنده: ${brief.requester || "ثبت نشده"}`,
        `تاریخ ثبت: ${brief.requestDate || "ثبت نشده"}`,
    ].join("\n");
}

function technicalInfo(brief) {
    return [
        `Backend Receipt: ${brief.technicalNotes?.backendReceiptPath || "ثبت نشده"}`,
        `BCR: ${brief.technicalNotes?.bcrPath || "ثبت نشده"}`,
        `Endpoint یا Contract: ${brief.technicalNotes?.knownEndpointOrContract || "ثبت نشده"}`,
        `توضیحات اضافه: ${brief.technicalNotes?.extraNotes || "ثبت نشده"}`,
    ].join("\n");
}

function buildFileName(featureName) {
    const slug = String(featureName || "feature")
        .trim()
        .replace(/[^\u0600-\u06FFa-zA-Z0-9]+/g, "-")
        .replace(/^-|-$/g, "") || "feature";
    const date = new Date().toISOString().slice(0, 10);
    return `zofino-codex-prompt-${slug}-${date}.docx`;
}
